<div id="header">
  <div class="left">
    <div class="btn-container">
      <h1>
        <a class="parent-app" [routerLink]="''" [title]="isInLiteMode ? 'Kyloe DataTools Lite Home' : 'Kyloe DataTools Home'">
          Kyloe DataTools
          <span *ngIf="isInLiteMode" class="dt-lite-logo">Lite</span>
        </a>
        <a class="parent-app" [routerLink]="getCurrentSection()" [title]="this.currentSection">
          | {{this.currentSection}}</a>
        <span *ngIf="this.currentChildSection" class="white-60-text"> | {{this.currentChildSection}}</span>
      </h1>
      <span class="section-header-icon"><i class="{{isCreditHistorySection ? 'Enrichment' : currentSection}}-KyloeIcon"></i></span>
    </div>
  </div>
  <div class="right">
    <div class="pendo-header-container"></div>
    <ul id="header-icons">
        <li
          *ngIf="currentSection === 'DataRules' && chainedRulesEnabled"
          [ngClass]="{
            'chain-link': true,
            'disabled': ruleChainsDataService.loading
             }"
            [matTooltip]="'Chained rules'" matTooltipShowDelay="500">
            <ng-container *ngIf="!ruleChainsDataService.loading && !dataRulesDataService.loading; else loadingChains">
              <span class="items-amount" >{{ruleChainsDataService.allSavedChains.length}}</span>
              <i
                #chainsTrigger
                class="material-icons notranslate" tabindex="0"
                [appCustomOverlayTriggerFor]="chainGroups"
                [disabled]="ruleChainsDataService.loading"
                [shouldClose]="shouldChainsClose.bind(this)"
                (closingEvent)="onChainTriggerClicked(true)"
                (click)="onChainTriggerClicked()"
              >playlist_play</i>
              <app-chained-rule-groups
                #chainGroups
                [overlayPositioningConfig]="chainsOverlayPositioningConfig"
                [chainsTrigger]="chainsTriggerRef"
                [navigateToChains]="navigateToChains.bind(this)"
                [navigateToDataRules]="navigateToDataRulesFromChainGroup.bind(this)"
                (chainClickedEventEmitter)="onChainClicked($event)"
              ></app-chained-rule-groups>
            </ng-container>
            <ng-template #loadingChains>
              <span
                class="spinner-border spinner-border-sm"></span>
              <i
                class="material-icons notranslate" tabindex="0"
              >playlist_play</i>
            </ng-template>
        </li>
      @if ((isEnrichmentSection || isCreditHistorySection) && creditBalance) {
        <li class="credit-counter header-pill"
            [class.header-pill--warning]="creditsExhausted"
            [matTooltip]="creditTooltip"
            matTooltipPosition="below"
            [matTooltipShowDelay]="500">
          <img [src]="creditIcon" alt="">
          <span>{{ creditsRemaining | compactNumberValues }} <span class="white-80-text">remaining</span></span>
        </li>
      }
      <li class="logged-in-as">
        <i class="material-icons notranslate">people</i>
        <span>{{corporationName}}</span>
      </li>
    </ul>
    <div class="right">
      <a href="http://www.KyloePartners.com" target="_blank" id="kyloe-logo-mask" class="white overlay-purple"
         [matTooltip]="'Visit our website'" matTooltipShowDelay="500"
         appRipple></a>
    </div>
  </div>
</div>
@if ((isEnrichmentSection || isCreditHistorySection) && creditsExhausted) {
  <div id="credit-limit-warn">
    <i class="material-symbols-outlined notranslate" aria-hidden="true">warning_amber</i>
    <p>Kyloe Credits Exhausted: Contact your Account Manager to purchase more.</p>
  </div>
}
<div class="message warning" [ngClass]="disabledDB ? '' : 'hide-height'">
  <span class="message-text">Warning: You are not authenticated to an enabled Bullhorn database</span>
  <span class="label-right">
    <i class="bhi-caution float-r"></i>
  </span>
</div>
<div class="message warning" [ngClass]="!userStatus() ? '' : 'hide-height'">
  <span
    class="message-text">Your account does not have permission please request access from your System Administrator</span>
  <span class="label-right">
    <i class="bhi-caution float-r"></i>
  </span>
</div>

<div *ngIf="maxNumberOfAutomatedRulesExceeded && currentSection === 'DataRules'" class="message info">
  <span class="message-text">You have reached the maximum number of automated DataRules available, please contact support&#64;kyloepartners.com</span>
</div>
<div *ngIf="!isAppEnabled" class="message info">
  <span class="message-text">Please note: <span class="text-capitalize">{{app}}</span> is not enabled.</span>
</div>

